import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { CustomerGuide } from '../../../employee/class/customer-guide';
import { CustomerGuideService } from '../../../employee/service/customer-guide/customer-guide.service';
import { TranslateService } from '@ngx-translate/core';
import { MapsAPILoader } from '@agm/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { Marker } from '../../../../interfaces/marker';
import { CompanyService } from '../../../employee/service/company/company.service';
import { HasPermissionService } from '../../../employee/service/has-permission/has-permission.service';
import { Message, FileUpload } from 'primeng/primeng';
import { config } from '../../../../../environments/config';
import { NotificationsService } from '../../../../theme/services/notifications/notifications.service';
import { UploadFilesCandidateService } from '../../services/upload-files-candidate/upload-files-candidate.service';
import { Candidate } from '../../../employee/class/candidate';
import { CandidateHvComponent } from '../candidate-hv/candidate-hv.component';
import { element } from 'protractor';

@Component({
  selector: 'app-attach-candidate-documentation',
  templateUrl: './attach-candidate-documentation.component.html',
  styleUrls: ['./attach-candidate-documentation.component.scss']
})
export class AttachCandidateDocumentationComponent implements OnInit, OnChanges {
  @Input() candidate_id: number;
  @Input() doc_candidate_input: any[];
  @Input() list_profile_survey_id_type: number;
  @Input() list_profile_survey_name: string;
  @Output() updateDocuments: EventEmitter<boolean> = new EventEmitter<boolean>();

  public apiUrl = config.API_ROOT;
  public loading_upload: boolean = false;
  public doc_candidate: any[] = [];
  public uploadedAttachment: any[] = [];
  public prewiewFileAttachment: any[] = [];
  public promiseAttachment: Promise<any>;
  
  @ViewChild('fileUpload') fileUpload: any;

  constructor(
    public hasPermissionService: HasPermissionService,
    private notificationsService: NotificationsService,
    public uploadFilesCandidateService: UploadFilesCandidateService,
    public translate: TranslateService,
  ) {

  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.doc_candidate = [];
    this.doc_candidate_input.forEach(element=>{
      if (element.list_profile_survey_id == this.list_profile_survey_id_type)
        this.doc_candidate.push(element);
    });
  }

  public onUploadFileDocumentProfileSurvey(event: any, item) {
    console.log (event);
    for (const file of event.srcElement.files) {
      this.uploadedAttachment[item.id] = file
    }
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.onload = () => {
        this.prewiewFileAttachment[item.id] = reader.result;
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  public addAttachmentDocument(event) {
    this.loading_upload = true;
    this.translate.get('uploading').subscribe((res: string) => {
      this.notificationsService.growlNotify('info', res + '...');
    });
    let uploadedAttachment = [];
    for (const file of event.files) {
      uploadedAttachment.push(file);
    }
    
    this.promiseAttachment = this.uploadFilesCandidateService.addAttachmentDocumentCandidate(uploadedAttachment, this.candidate_id, this.list_profile_survey_id_type).toPromise().then(
      response => {
        this.fileUpload.clear();
        this.loading_upload = false;
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
        });
        this.updateDocuments.emit(true);
      },
      error => {
        this.loading_upload = false;
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public gotoAttachmentDocumentProfileSurvey(id) {
    window.open(this.apiUrl + '/documents-candidate/' + id + '/attachment' + '?token=' + localStorage.getItem('token'), '_blank');
  }

  public deleteAttachmentDocumentProfileSurvey(id) {
    this.promiseAttachment = this.uploadFilesCandidateService.deleteAttachmentDocumentCandidate(id).toPromise().then(
      response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.notificationsService.growlNotify('success', res);
          
        });
        this.updateDocuments.emit(true);
        // this.showDocumentationDialog(this.selectCitation,this.selectCitationType);
        // const index = this.findElement(this.uploadedAttachment, id);
        // if (index > -1) {
        //   this.uploadedAttachment.splice(index, 1);
        // }                
        // console.log(this.uploadedAttachment);
      },
      error => {
        let msg = '';
        this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
          this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
            JSON.parse(error._body).errors.forEach(element => {
              if (element.source) {
                if (element.source.pointer) {
                  this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    msg = msg + res3 + ', ';
                  });
                }
              }
            });
            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
          });
        });
      }
    );
  }

  public findElement (list, search) {
    let find = -1;
    let itera = 0;
    list.forEach(element => {
      if (element.id === search) {
        find = itera;
      }
      itera++;
    });
    return find;
  }

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/candidate/components/attach-candidate-documentation/attach-candidate-documentation.component.ts